export default __webpack_public_path__ + "static/media/p3.5c01516f.png";